import './home.scss';

$(function () {
	$('.home').each(function () {
		let $home = $(this);

		$home.on('click', '.more-videos__video', function () {
			const videoId = $(this).attr('data-video-id');

			const $popup = $home.find('.video-popup');
			const $popupVideo = $popup.find('.video-popup__video');
			$popupVideo.prop('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`);
			$popup.addClass('video-popup_open');
		});

		$home.on('click', '.video-popup .video-popup__close', function () {
			let $popup = $(this).closest('.video-popup');
			let $popupVideo = $popup.find('.video-popup__video');
			$popup.removeClass('video-popup_open');
			$popupVideo.prop('src', '');
		});

		$(document).on('mouseup', function (e) {
			const $popup = $home.find('.video-popup');
			const $popupOverlay = $popup.find('.video-popup__container');

			if ($popupOverlay.is(e.target) || $popupOverlay.has(e.target).length !== 0) {
				return;
			}

			const $popupVideo = $popup.find('.video-popup__video');
			$popup.removeClass('video-popup_open');
			$popupVideo.prop('src', '');
		});
	});
});
